import React from "react";
import BackButton from "../components/BackButton"; 

function PrivacyPolicy() {
    return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "50px", fontFamily: "'Poppins', sans-serif" }}>
            
            <div className="pb-5 pt-4 px-3 position-relative overflow-hidden"
                style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <BackButton className="text-white" />
                    <div style={{ width: 30 }}></div>
                </div>
                <div className="text-center pb-3">
                    <h3 className="fw-bolder text-white mb-1">Privacy Policy</h3>
                    <p className="text-white opacity-75 small mb-0">We value your trust and data</p>
                </div>
            </div>

            <div className="container px-3" style={{ marginTop: "-30px" }}>
                <div className="card border-0 shadow-sm rounded-4 p-4 animate-up mb-4">
                    <p className="text-muted small mb-4" style={{ lineHeight: "1.6" }}>
                        At Win11 Fantasy, safeguarding your privacy is our top priority. This policy outlines how we collect, use, and protect your personal information.
                    </p>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-database-fill text-danger me-2"></i>1. Information We Collect</h6>
                        <ul className="text-muted small" style={{ lineHeight: "1.7", paddingLeft: "1.2rem" }}>
                            <li><b>Account Info:</b> Full Name, Email address, and Mobile number provided during registration.</li>
                            <li><b>Financial & KYC Info:</b> PAN Card details, Bank Account numbers, and UPI IDs collected securely for verification and withdrawal processing.</li>
                            <li><b>Technical Data:</b> IP addresses, device identifiers, and platform interaction logs to prevent fraud.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-cpu-fill text-danger me-2"></i>2. How We Use Your Data</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            Your data is strictly utilized to operate your account, verify your identity for legal compliance, process transactions securely, notify you of match updates, and enhance our platform's security against unauthorized access.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-lock-fill text-danger me-2"></i>3. Data Security & Storage</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            We implement robust, industry-standard encryption protocols (SSL) to protect your data during transmission. We <b>do not</b> store your credit/debit card PINs, CVVs, or UPI PINs on our servers. All payment processing is handled by compliant third-party gateways.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-share-fill text-danger me-2"></i>4. Third-Party Sharing</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            Win11 does not sell or rent your personal information to marketers. We only share necessary data with trusted legal and payment partners (like Razorpay) strictly for executing your requested transactions or when mandated by government authorities.
                        </p>
                    </div>

                    <div className="policy-section border-0 mb-0">
                        <h6 className="fw-bold text-dark"><i className="bi bi-trash-fill text-danger me-2"></i>5. Account Deletion & Data Rights</h6>
                        <p className="text-muted small mb-0" style={{ lineHeight: "1.7" }}>
                            Users have the right to request permanent deletion of their account via the App Settings. Upon verification of the request, all personal data will be erased within 12-24 hours, except data legally required to be retained for tax and audit purposes.
                        </p>
                    </div>
                </div>
            </div>

            <style>{`
                .animate-up { animation: fadeInUp 0.4s ease-out both; }
                .policy-section { border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px; }
                @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}

export default PrivacyPolicy;